import { User } from "../@core/data/users";

export class Person {
  id?: string;
  email?: string;
  mobile?: string;
  cardId?: string;

  fullName?: string;
  firstName?: string;
  lastName?: string;
  dob?: Date;
  dobYear?: number;
  dobMonth?: number;
  dobDay?: number;
  gender?: string;
  address?: string;
  description?: string;
  tax?: string;

  tags?: string[];
  coverUrl?: string;

  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images

  customerId?: string;
  customerName?: string;
  supplierId?: string;
  supplierName?: string;
  employeeId?: string;
  employeeName?: string;
  projectId?: string;
  projectName?: string;

  shopId?: string;
  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}
